import { render, staticRenderFns } from "./JdsWorkbenchHeader.vue?vue&type=template&id=18b4887a&scoped=true&"
import script from "./JdsWorkbenchHeader.vue?vue&type=script&lang=ts&"
export * from "./JdsWorkbenchHeader.vue?vue&type=script&lang=ts&"
import style0 from "./JdsWorkbenchHeader.vue?vue&type=style&index=0&id=18b4887a&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b4887a",
  null
  
)

export default component.exports